import { CurrentItem } from "./types";

export function nearestItemTo<R>(time: Date, items: CurrentItem<Date, R>[]): CurrentItem<Date, R> {
  let sortedItems = [...items];
  const distToTime = (t: Date) => Math.abs(t.valueOf() - time.valueOf());
  sortedItems.sort((a, b) => distToTime(a.x) - distToTime(b.x));

  return sortedItems[0];
}
